import PropTypes from "prop-types"
import React from "react"

import { Context } from "../../utility/context"

const Header = () => (
  <Context.Consumer>
    {context => (
      <div className="col col-12 bg-mercer-glass-light fg-mercer-blue-dark p2 md-py2 md-px3 mb2 relative">
        <div className="col col-12 center">
          <h1 className="mt0">{context.selected.monthly.header.title}</h1>
          <div className="col col-12">
            <p>{context.selected.monthly.header.content}</p>
          </div>
        </div>
        <div className="col col-12 mt2">
          <div className="sm-flex flex-justify-center">
            <div className="md-px2 flex">
              <a href={context.selected.monthly.header.link1} target="_parent"  className="btn btn-primary col fg-mercer-gray-dark bg-mercer-yellow-mid black mx-auto center" style={{width: "280px"}}>Have a Question?</a>
            </div>
            <div className="md-px2 md-ml3 flex">
              <a href={context.selected.monthly.header.link2} target="_parent" className="btn btn-primary col fg-mercer-gray-dark bg-mercer-yellow-mid black mx-auto center" style={{width: "280px"}}>Subscribe To Newsletter</a>
            </div>
          </div>
        </div>
      </div>
    )}
  </Context.Consumer>
);

Header.propTypes = {
  block: PropTypes.shape({
    title: PropTypes.string,
    content: PropTypes.string,
    link1: PropTypes.string,
    link2: PropTypes.string,
  }),
}

Header.defaultProps = {
  block: {
    title: ``,
    content: ``,
    link1: ``,
    link2: ``,
  },
}

export default Header
